export const userCertifications = Object.freeze([
  {
    value: 'quest_designer',
    text: 'Quest Designer'
  },
  {
    value: 'internal_reviewer',
    text: 'Internal Reviewer'
  },
  {
    value: 'publication_reviewer',
    text: 'Publication Reviewer'
  }
])



// WEBPACK FOOTER //
// ./src/constants/usercertifications.js